import { Typography } from '@mui/material'
import { Alert } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { CoData, CoQuery } from './co-query-wrapper'

export type LayoutLoadingErrorProps = {
  data: CoQuery
  children: (data: CoData) => React.ReactNode
}
export function LayoutLoadingError({ data, children }: LayoutLoadingErrorProps) {
  const { t } = useTranslation()

  switch (data.mode) {
    case 'LOADING':
      return <></>
    case 'ERROR':
      return (
        <Alert severity="error">
          <Typography>{t('pms.common.checkout_document.details.query_error')}</Typography>
        </Alert>
      )

    default:
      return <>{children(data)}</>
  }
}
